module.exports = __webpack_public_path__ + "img/img2.2d78bc75.jpg";